export default "__VITE_ASSET__huI6gOwR__"